import React from "react";

const PaymentSuccess = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>
          <span>&#10004;</span>
        </div>
        <h1 style={styles.title}>Payment Successful!</h1>
        <p style={styles.message}>
          Thank you for your purchase. Your payment has been processed
          successfully.
        </p>
        <button
          style={styles.button}
          onClick={() => {
            window.location = "/search";
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f8ff",
  },
  card: {
    textAlign: "center",
    backgroundColor: "#ffffff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  icon: {
    fontSize: "50px",
    color: "#4caf50",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    color: "#333333",
    marginBottom: "10px",
  },
  message: {
    fontSize: "16px",
    color: "#666666",
  },
  button: {
    marginTop: "20px",
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#4caf50",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default PaymentSuccess;
